import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { allRemoteSettingsSelect } from '../../../redux/selectors/index';
import { SiteWide } from "../../../utility/customComponents";

const AuthHolder = (props) => {
    const navigate = useNavigate();
    const site_settings = useSelector(allRemoteSettingsSelect);

    return (
        <SiteWide pageTitle={props.title} themeColor={"#1e1e2d"}>
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 p-4">
                <div className="w-full max-w-md">
                    <div className="mb-6 flex justify-center">
                        <div className="flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-blue-500 animate-pulse"></div>
                            <div className="h-2 w-2 rounded-full bg-purple-500 animate-pulse delay-75"></div>
                            <div className="h-2 w-2 rounded-full bg-pink-500 animate-pulse delay-150"></div>
                        </div>
                    </div>
                    
                    <div className="relative overflow-hidden rounded-xl border border-slate-700 bg-slate-800/90 backdrop-blur-lg shadow-2xl">
                        {/* Glass effect top accent */}
                        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-70"></div>
                        
                        {/* Animated background gradient */}
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(56,189,248,0.2),transparent_25%),radial-gradient(circle_at_70%_60%,rgba(168,85,247,0.2),transparent_25%)] pointer-events-none"></div>
                        
                        {props.children}
                        
                        {/* Glass effect bottom accent */}
                        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-slate-500 to-transparent opacity-30"></div>
                    </div>
                    
                    <div className="mt-6 text-center text-xs text-slate-400">
                        &copy; {new Date().getFullYear()} | All rights reserved.
                    </div>
                </div>
            </div>
        </SiteWide>
    );
};

export default AuthHolder;